export default [
  {
    path: '/rollVideo',
    name: 'rollVideo',
    component: () => import('@/views/shortVideo/RollVideo.vue'),
    meta: { title: '小视频', customWechatShare: true, pageLevel: 3 }
  },
  {
    path: '/previewVideo',
    name: 'previewVideo',
    component: () => import('@/views/shortVideo/PreviewVideo.vue'),
    meta: { title: '小视频', customWechatShare: true }
  },
  {
    path: '/publishVideo',
    name: 'publishVideo',
    component: () => import('@/views/shortVideo/publishVideo.vue'),
    meta: { title: 'add_short_video', customWechatShare: true }
  }
]
